import { useState } from "react";
import FormField from "../../../shared/components/FormField";
import { useAsync } from "../../../shared/hooks/useAsync";
import { authenticationApi } from "../api/authentication.api";
import { validators } from "../validation/authentication.validation";

export default function ResetPasswordForm({ token, onSuccess }) {
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [fieldErrors, setFieldErrors] = useState({});
    const [done, setDone] = useState(false);
    const { run, loading, error } = useAsync();

    const handleSubmit = async (e) => {
        e.preventDefault();

        const passwordError = validators.password(newPassword);
        const confirmError = newPassword !== confirmPassword ? "Passwords don't match" : null;
        setFieldErrors({ newPassword: passwordError, confirmPassword: confirmError });
        if (passwordError || confirmError) return;

        const data = await run(() => authenticationApi.resetPassword(token, newPassword));
        if (data) setDone(true);
    };

    if (done) {
        return (
            <div className="ogm-auth-form">
                <p className="ogm-auth-success" style={{ textAlign: "left" }}>
                    Your password has been reset. You can now log in with your new password.
                </p>
                <span className="ogm-back-link" onClick={onSuccess} role="button" tabIndex={0}>
                    ← Back to Login
                </span>
            </div>
        );
    }

    return (
        <form className="ogm-auth-form" onSubmit={handleSubmit} noValidate>
            <p className="ogm-otp-sent-to">Choose a new password for your account.</p>

            <FormField
                type="password"
                placeholder="New password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                error={fieldErrors.newPassword}
                autoFocus
                required
            />

            <FormField
                type="password"
                placeholder="Confirm new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                error={fieldErrors.confirmPassword}
                required
            />

            {error && (
                <p className="ogm-auth-error" role="alert">
                    {error}
                </p>
            )}

            <button className="ogm-primary-btn" disabled={loading} type="submit">
                {loading ? "Resetting…" : "Reset password"}
            </button>
        </form>
    );
}
